import { useTranslation } from 'react-i18next';
import { PlannedDuty } from '../types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import getCommonTooltipContent from '../TooltipContent';
import { Icon } from '@sdb/planning-ui';

export default function TooltipContent(duty: PlannedDuty) {
  const { t } = useTranslation('common');
  // const { isDutyHourTypeChanged } = duty;
  const isDutyHourTypeChanged = false;
  const commonContent = getCommonTooltipContent(duty);
  // const isNotFromBaseplan = !isFromBasePlan;
  const isNotFromBaseplan = false;
  const hasContent =
    commonContent ||
    isDutyHourTypeChanged ||
    isNotFromBaseplan ||
    !duty.isPublished ||
    duty?.assignedEmployee?.phoneNumber ||
    duty?.assignedEmployee?.smsNumber;

  if (!hasContent) return '';

  return (
    <Table size="small" sx={{ 'tr:last-child td': { border: 0 } }}>
      <TableBody>
        {!duty.isPublished && (
          <TableRow>
            <TableCell colSpan={2}>
              <strong>
                <i>{t('notPublished')}</i>
              </strong>
            </TableCell>
          </TableRow>
        )}
        {isNotFromBaseplan && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="chevron-up" fontSize="small" />
            </TableCell>
            <TableCell>{t('notFromBaseplan')}</TableCell>
          </TableRow>
        )}
        {isDutyHourTypeChanged && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="asterisk" fontSize="small" />
            </TableCell>
            <TableCell>{t('dhtChanged')}</TableCell>
          </TableRow>
        )}
        {commonContent}
        {duty?.assignedEmployee?.smsNumber && (
          <TableRow>
            <TableCell />
            <TableCell>
              <div>
                <strong>{t('mobileNumber')}</strong>
              </div>
              {duty?.assignedEmployee?.smsNumber}
            </TableCell>
          </TableRow>
        )}
        {duty?.assignedEmployee?.phoneNumber && (
          <TableRow>
            <TableCell />
            <TableCell>
              <div>
                <strong>{t('phoneNumber')}</strong>
              </div>
              {duty?.assignedEmployee?.phoneNumber}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
